import {Resource, ResponseSerialize} from 'simpli-web-sdk'
import {DocumentType} from '@/model/resource/DocumentType'
import {CargoAudit} from '@/model/resource/CargoAudit'

export class CargoInfo extends Resource {
  idCargoFk: number = 0

  receiverName: string | null = null

  @ResponseSerialize(DocumentType)
  receiverDocumentType: DocumentType | null = null
  receiverDocument: string | null = null
  tipoLinea: string | null = null
  tipoOrden: string | null = null

  @ResponseSerialize(CargoAudit)
  cargoAudit: CargoAudit = new CargoAudit()

  get $id() {
    return this.idCargoFk
  }
  set $id(val) {
    this.idCargoFk = val
  }

  get $tag() {
    return String(this.idCargoFk)
  }

  get idReceiverDocumentTypeFK() {
    if (this.receiverDocumentType) {
      return this.receiverDocumentType.$id
    }
    return null
  }
  set idReceiverDocumentTypeFK(val) {
    if (!this.receiverDocumentType) {
      this.receiverDocumentType = new DocumentType()
    }
    if (val !== null) {
      this.receiverDocumentType.$id = val
    } else {
      this.receiverDocumentType.idDocumentTypePk = null
    }
  }
}
